<template>
  <div class="grid-item">
    <router-link :to="route"
                 :title="restaurant.title"
                 class="grid-item__inner"
    >
      <picture class="grid-item__bg-wrap">
        <source :srcset="restaurant.background_image_preview"
                media="(max-width: 767px)"
        >
        <img :src="restaurant.background_image"
             :alt="restaurant.title"
             class="grid-item__bg"
        >
      </picture>
      <span class="grid-item__logo-wrap">
        <img :src="restaurant.image_transparent"
             :alt="restaurant.title"
             class="grid-item__logo"
        >
      </span>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'GridItem',
    props: {
      restaurant: {
        type: Object
      }
    },
    computed: {
      route() {
        if (this.restaurant.category) {
          return {
            name: 'restaurant-with-category',
            params: {
              id: this.restaurant.id,
              categoryId: this.restaurant.category.id,
              slug: this.restaurant.slug,
              categorySlug: this.restaurant.category.slug
            }
          }
        } else {
          return {
            name: 'restaurant',
            params: {
              id: this.restaurant.id,
              slug: this.restaurant.slug,
            }
          }
        }
      }
    },
    created() {
      // console.log(this.restaurant)
    }
  }
</script>

<style>

</style>
